import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const StoryPage = lazy(
  () => import('./StoryPage.eager').then(mod => ({default: mod.StoryPage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
